<template>
  <layout-default-app-bar :back-to="true">
    Visita
  </layout-default-app-bar>
</template>

<script>

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },
};

</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>
